import { Box, ButtonBase, useTheme } from '@material-ui/core';
import { SearchFormOptions } from '@setvi/shared/components/intelligence/product-match/enums';
import { SearchType } from '@setvi/shared/components/intelligence/search/interfaces';
import { AISearch } from 'pages/products/hooks/use-ai-search-result';
import { Breadcrumb, Category } from 'Services/MongoRealm/Types';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { SBreadcrumbs, SText } from '@setvi/shared/components';
import { Divider, Wrapper } from '../styled';

// const iconStyle = { fontSize: 19 };

export interface HeaderProps {
  selectedCategory: Category;
  searchContent: SearchType;
  showAIInput: boolean;
  searchQuery: string;
  feedback: JSX.Element;
  // viewMode: Views;
  // toggleViewMode: () => void;
  closeAISearchMode: () => void;
  closeSearchMode: () => void;
  handleSearch: (val: {
    type: SearchType;
    search: AISearch;
    aiType?: SearchFormOptions;
  }) => void;
  onSelectCategory: (categoryId: Category['_id']) => void;
  handleOpenCategoryDrawer?: () => void;
}

export const RegularHeader = ({
  selectedCategory,
  onSelectCategory,
  handleOpenCategoryDrawer
}: Pick<
  HeaderProps,
  'selectedCategory' | 'onSelectCategory' | 'handleOpenCategoryDrawer'
>) => {
  // const [searchParams, setSearchParams] = useSearchParams();
  const { palette } = useTheme();

  const breadcrumbs = selectedCategory
    ? ([
        { _id: null as any, name: 'All Categories' },
        ...selectedCategory.breadcrumbs
      ] as Breadcrumb[])
    : [];

  // const viewModeToggler = (
  //   <ButtonGroup>
  //     <Button
  //       onClick={() => {
  //         refetchProducts();
  //         toggleViewMode();
  //         searchParams.set(
  //           'view',
  //           searchParams.get('view') === Views.GRID_VIEW
  //             ? Views.LIST_VIEW
  //             : Views.GRID_VIEW
  //         );
  //         setSearchParams(searchParams);
  //       }}>
  //       {viewMode !== Views.GRID_VIEW ? (
  //         <Grid fill={TextColor.SlateGrey} style={iconStyle} />
  //       ) : (
  //         <List fill={TextColor.SlateGrey} style={iconStyle} />
  //       )}
  //     </Button>
  //   </ButtonGroup>
  // );

  return (
    <>
      <Wrapper
        py={2}
        px="20px"
        style={{ backgroundColor: palette.common.white }}>
        <Box display="flex" alignItems="center" gridGap="8px">
          <ButtonBase
            onClick={() => handleOpenCategoryDrawer()}
            style={{
              backgroundColor: '#F8F9FA',
              borderRadius: 12,
              padding: '6px 12px'
            }}>
            <SText
              title={selectedCategory?.name || 'All Categories'}
              weight="bold"
            />
            <ArrowForwardIosIcon
              style={{
                fontSize: 10,
                marginLeft: 11,
                transform: 'rotate(90deg)'
              }}
            />
          </ButtonBase>
        </Box>
        {/* {viewModeToggler} */}
      </Wrapper>
      <Divider />
      {!!breadcrumbs?.length && (
        <SBreadcrumbs<Breadcrumb>
          style={{ margin: '0px 20px 12px 20px' }}
          maxItems={2}
          parseBreadcrumb={breadcrumb => breadcrumb?.name}
          onBreadcrumbClick={breadcrumb => onSelectCategory(breadcrumb?._id)}
          items={breadcrumbs}
        />
      )}
    </>
  );
};
